import getPageType from './getPageType';
import logEvent from './logEvent';
import useInit from './useInit';
import useLogPageView from './useLogPageView';
export * from './utils';

export {
  useInit,
  useLogPageView,
  logEvent,
  getPageType,
};
